import React from "react";
import { Container, Logo, BackButtonContainer, BackIcon, ButtonText, MaxWidth  } from "./styles/header";

export default function Header({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}

Header.MaxWidth = function HeaderMaxWidth({children, ...props}){
  return <MaxWidth {...props}>{children}</MaxWidth>
}


Header.Logo = function HeaderLogo({ ...props }) {
  return <Logo {...props} />;
};

Header.BackButtonContainer = function HeaderBackButtonContainer({children, ...props }) {
  return <BackButtonContainer {...props} >{children}</BackButtonContainer>;
};

Header.BackIcon = function HeaderBackIcon({...props }) {
  return <BackIcon {...props} />;
};

Header.ButtonText = function HeaderButtonText({children,...props}) {
  return <ButtonText {...props} >{children}</ButtonText>;
};